<div class="blc">
  <div style="display: flex;align-items: center;justify-content: center;">
    <div class="proof" [style.backgroundColor]="proofColor"></div>
  </div>
  <ion-range
    min="0" max="255"
    dualKnobs="false" pin="false"
    snaps="true" step="1"
    ticks="false" [value]="color.red"
    color="primary"
    (ionChange)="update('RED', $event)">
    <span slot="start">Rouge</span>
  </ion-range>
  <ion-range
    min="0" max="255"
    dualKnobs="false" pin="false"
    snaps="true" step="1"
    ticks="false" [value]="color.green"
    color="success"
    (ionChange)="update('GREEN', $event)">
    <span slot="start">Verte</span>
  </ion-range>
  <ion-range
    min="0" max="255"
    dualKnobs="false" pin="false"
    snaps="true" step="1"
    ticks="false" [value]="color.blue"
    color="tertiary"
    (ionChange)="update('BLUE', $event)">
    <span slot="start">Bleu</span>
  </ion-range>
</div>